import { render, staticRenderFns } from "./Pivot.vue?vue&type=template&id=a3729a5e&scoped=true&"
import script from "./Pivot.vue?vue&type=script&lang=js&"
export * from "./Pivot.vue?vue&type=script&lang=js&"
import style0 from "./Pivot.vue?vue&type=style&index=0&id=a3729a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3729a5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VSelect,VSwitch,VTooltip})
